import { useSelector } from 'react-redux';
import DefaultWidgetTemplate from '../DefaultWidgetTemplate';

const ChemicalTradingDefaultWidget = (props) => (
  <DefaultWidgetTemplate
    module={props.module}
    route="user_module_chemicalTrading_home"
  />
);

export default ChemicalTradingDefaultWidget;
